import moment from "moment/moment";
import React, { useState } from "react";
import { t } from "../../../../../utils/i18n";

const TradeInfo = ({
  tradeId,
  tradeCreatedAt,
  sellerRate,
  offerFiatCurrencyCode,
  customOfferLabel,
}) => {
  const [copied, setCopied] = useState(null);

  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopied(field);
    setTimeout(() => setCopied(false), 2000);
};

  return (
    <div>
      <p className="tradedetails-tradeinfo-title">
        <span>{t("p2p.trade_info.title")}</span>
      </p>
      <div className="tradedetails-tradeinfo-section">
        <div>
          <div className="tradedetails-tradeinfo-specifics">
            <div>
              <div className="tradedetails-tradeinfo-specifics-text"  title={t("p2p.rate.price_tip")}>
                <p className="tradedetails-tradeinfo-specifics-textnames">
                <i className="fas fa-star"></i>
                  {" "}{t("p2p.trade_info.name")}
                </p>
                <p className="tradedetails-tradeinfo-specifics-textvalues">{customOfferLabel}</p>
              </div>
            </div>
            <div>
              <div className="tradedetails-tradeinfo-specifics-text"  title={t("p2p.rate.price_tip")}>
                <p className="tradedetails-tradeinfo-specifics-textnames">
                  <i className="fas fa-chart-pie"></i>
                  {" "}{t("p2p.trade_info.rate")}
                </p>
                <p className="tradedetails-tradeinfo-specifics-textvalues">{t("p2p.trade_info.rate_value", { rate: parseFloat(sellerRate).toFixed(2), currency: offerFiatCurrencyCode })}</p>
              </div>
            </div>
            <div className="tradedetails-tradeinfo-specifics-text" title={t("p2p.trade_info.id_tip")}>
              <p className="tradedetails-tradeinfo-specifics-textnames">
                <i className="fas fa-bullseye"></i>
                {" "}{t("p2p.trade_info.id")}
              </p>
              <p className="tradedetails-tradeinfo-specifics-textvalues">{tradeId}
                <button onClick={() => handleCopy(tradeId, "tradeId")} className="tradedetails-copybtn">
                  <i className={`fas fa-${copied === "tradeId" ? "check" : "copy"}`} title={copied ? t("p2p.common.copied") : t("p2p.common.copy")}></i>
                </button>
              </p>
            </div>
            <div className="tradedetails-tradeinfo-specifics-text" title={t("p2p.trade_info.started_tip")}>
              <p className="tradedetails-tradeinfo-specifics-textnames">
                <i className="fas fa-stopwatch"></i>
                {" "}{t("p2p.trade_info.started")}
              </p>
              <p className="tradedetails-tradeinfo-specifics-textvalues">
                {moment.utc(tradeCreatedAt).local().format("lll")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradeInfo;
